var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "table table-order" },
    [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.columns, function(column) {
            return _c("th", { key: column }, [_vm._v(_vm._s(column))])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.productGroups, function(productGroup, index) {
        return _c("order-table-group-component", {
          key: productGroup.PlantClassID,
          attrs: { productGroup: productGroup, index: index }
        })
      }),
      _vm._v(" "),
      !_vm.productGroups.length
        ? _c("tbody", [
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { colspan: _vm.columns.length }
                },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("No products match your search")
                  ])
                ]
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }